import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useSearchParams } from 'react-router-dom';
import { Card } from 'react-bootstrap';

import ApiService from 'helpers/apiService';
import getQueryParams from 'helpers/getQueryParams.hl';

import { IProviderTypes } from './types';
import ProvidersTable from './ProvidersTable';


type FiltersTypes = {
  name?: string;
};

const Providers = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [providers, setProviders] = useState<IProviderTypes[]>([]);
  const [adding, setAdding] = useState(false);

  const params = getQueryParams(searchParams);

  const fetchData = async (query: FiltersTypes) => {
    setLoading(true);
    try {
      const response = await ApiService.getProviders<{ data: IProviderTypes[] }>(query);
      setProviders(response.data);
    } catch (error) {
      console.error('Ошибка при загрузке данных:', error);
    } finally {
      setLoading(false);
    }
  };

  const filterForm = useFormik({
    initialValues: {
      name: ''
    },
    onSubmit: async (vals) => {
      setSearchParams(vals as any);
      await fetchData(vals);
    }
  });

  const addForm = useFormik({
    initialValues: {
      name: '',
      service: ''
    },
    onSubmit: async (vals, { resetForm }) => {
      setAdding(true);
      try {
        await ApiService.addProvider(vals);
        resetForm();
        await fetchData(filterForm.values);
      } catch (error) {
        console.error('Ошибка при добавлении:', error);
      } finally {
        setAdding(false);
      }
    }
  });

  useEffect(() => {
    if (!Object.keys(params).length) {
      filterForm.handleSubmit();
    } else {
      filterForm.setValues(params as any);
      fetchData(params as FiltersTypes);
    }
  }, []);

  return (
    <Card>
      <Card.Body>
        {loading ? (
          <div>Загрузка...</div>
        ) : (
          <>
            <ProvidersTable
              data={providers}
              loading={loading}
              setLoading={setLoading}
              getProviders={() => fetchData(filterForm.values)}
            />

            {/* Форма добавления */}
            <hr />
            <h5>Добавить провайдера</h5>
            <form onSubmit={addForm.handleSubmit} className="d-flex gap-3 align-items-end">
              <div>
                <label>Имя</label>
                <input
                  type="text"
                  className="form-control"
                  value={addForm.values.name}
                  name = "name"
                  onChange={(e) => addForm.setFieldValue('name', e.target.value)}
                />
              </div>
              <div>
                <label>Сервис</label>
                <input
                  type="text"
                  className="form-control"
                  value={addForm.values.service}
                  name = "service"
                  onChange={(e) => addForm.setFieldValue('service', e.target.value)}
                />
              </div>
              <button
                type="submit"
                className="btn btn-success"
                disabled={adding}
              >
                Добавить
              </button>
            </form>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default Providers;
